import { forwardRef } from 'react';
import { pathgen } from 'object-path-generator';
import { Button, MenuItem, SplitButton, useOverlayContext } from 'seagull';
import { useEventReporter } from "../../event-reporter";
import { useRedirectToProposal } from "../../hooks/useCreateAgreement";
import styles from "./CreateProposalButton.module.scss";
import { useProposalTemplates } from "./hooks/useProposalTemplates";
import { SelectProposalTypeModal } from "./SelectProposalTypeModal/SelectProposalTypeModal";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const CreateProposalButtonTestIds = pathgen('CreateProposalButtonTestIds');
export const CreateProposalButton = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    text = 'Create proposal',
    hideTemplatePicker = false
  } = props;
  const {
    reportButtonClick
  } = useEventReporter();
  const {
    openCreationModal
  } = useRedirectToProposal();
  const {
    templates,
    isLoading
  } = useProposalTemplates({
    refreshOnMount: true
  });
  const hasProposalTemplates = !!(templates !== null && templates !== void 0 && templates.length);
  const overlayContext = useOverlayContext();
  const openSelectProposalTypeModal = proposalType => {
    overlayContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/_jsx(SelectProposalTypeModal, {
          dismissModal: dismissModal,
          proposalType: proposalType
        });
      }
    });
  };
  const openNewProposal = async () => {
    reportButtonClick('topbar-new-agreement-btn');
    if (hasProposalTemplates) {
      openSelectProposalTypeModal();
      return;
    }
    await openCreationModal();
  };
  const openNewProposalFromDraft = async () => {
    reportButtonClick('topbar-new-agreement-btn');
    await openCreationModal();
  };
  const onNewTemplate = async () => {
    openSelectProposalTypeModal('template');
  };
  return !hideTemplatePicker && hasProposalTemplates ? /*#__PURE__*/_jsx(SplitButton, {
    label: text,
    "data-testid": CreateProposalButtonTestIds.SplitButton.Root(),
    onClick: openNewProposal,
    popperClassName: styles.popper,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(MenuItem, {
        onClick: onNewTemplate,
        "data-testid": CreateProposalButtonTestIds.SplitButton.NewTemplateOption(),
        children: "Use a template"
      }), /*#__PURE__*/_jsx(MenuItem, {
        onClick: openNewProposalFromDraft,
        "data-testid": CreateProposalButtonTestIds.SplitButton.NewProposalOption(),
        children: "Start from scratch"
      })]
    })
  }) : /*#__PURE__*/_jsx(Button, {
    "data-testid": CreateProposalButtonTestIds.Button(),
    onClick: openNewProposal,
    ref: ref,
    loading: isLoading,
    children: text
  });
});